import { HttpClient } from "@angular/common/http";
import { inject } from "@angular/core";
import { CHATBOT_CONFIG } from "../config";

export abstract class BaseApiService {
    protected readonly _http = inject(HttpClient);
    protected readonly _apiUrl = inject(CHATBOT_CONFIG).apiUrl;

    /** The API resource this service talks to, e.g. `'sessions'`. */
    protected abstract readonly resourcePath: string;

    protected get _baseUrl(): string {
        return `${this._apiUrl}/${this.resourcePath}`;
    }
}
